
import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Footer from './Components/Footer/Footer';
import Navbar from './Components/Navbar/Navbar';
import Homepage from './Pages/Homepage/Homepage';
import { Box } from "@chakra-ui/react"
import Login from './Pages/LoginSignup/Login';
import Signup from './Pages/LoginSignup/Signup';
// import { useSelector } from 'react-redux';
import Rent from './Components/Rent_Page/rent';
import { Yourinput } from './Components/Rent_Page/components/Input';
import Payment from './Components/Payment_Detail/payment';
import ToPayment from './Components/Card_Detail_Page/payment';
import OtpPage from './Pages/LoginSignup/OtpPage';
import SubNavBar from './Components/Navbar/subNavbar/subNavbar';
import AddProperty from './Pages/Property/AddProperty/addproperty';
import PropertyDetailPage from './Pages/Property/detailpage';
import ProfilePage from './Pages/profilePage';
import EditProperty from './Pages/Property/Edit/edit';
import AddProperty2 from './Pages/Property/AddProperty/addproperty2';
import PrivateRoute from './routes/PrivateRoute';
import EditProfilePage from './Pages/editProfilePage';
import SearchResultPage from './Pages/resultPage';
import AddPropertyPage from './Pages/Property/AddProperty';
import { Toaster } from 'react-hot-toast';
import BankAunctionPage from './Pages/bankAunction';
import MapView from './Components/mapView/mapview';
import SearchMapComponent from './Components/mapView/searchMap';
import AddServiceForm from './Pages/Services/AddServices/add';
import VoiceInput from './Components/VoiceInput/VoiceInput';
import AddProjectPage from './Pages/Project/AddProject';
import AllPropertyPage from './Pages/Property/AllProperties/allProperty';
import RelationShipManagementPage from './Pages/RelationShipManagement';
import ServiceListPage from './Pages/Services/list';
import LocationComponent from './Components/City/city';
import AddPropertyComponent from './Components/LandMarksLocation';
import ProjectDetailsPage from './Pages/Project/detail/detail';
import { GoogleMapsLoader } from './routes/GoogleMapsLoader';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import ShowPropertyGalleryPage from './Pages/Property/showGallery/showGallery';
import AllImagesPage from './Pages/Property/showGallery/allimages/allimages';
import ProjectsSearchListPage from './Pages/Project/searchlist/searchlist';
import BankAunctionPage2 from './Pages/bankAunction/index2';
import RelationshipManager from './Components/RelationshipManager/RelationshipManager';
import HelpCenterButton from './Components/common/HelpCenterButton';
// import MapView from './Components/mapView/mapview';

import AOS from "aos";
import "aos/dist/aos.css";
import { banner_bg } from './Utils/export';
import EMICalculator from './Pages/EMICalculator/EMICalculator';
import AllServices from './Pages/AllServices/AllServices';
import LocationSearch from './Components/LocationSearch';
import AboutPage from './Pages/aboutUs/about';

function App() {
  const location = useLocation(); // Current path ko get karne ke liye

  const hideNavAndFooter = location.pathname === "/userdashboard"; // Agar /userdashboard hai to true hoga

  const isHomePage = location.pathname === "/";

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
    });
    // Refresh AOS on every render if dynamic content is added
    AOS.refresh();
  }, []);



  return (
    // <GoogleMapsLoader>
    <div
      className={isHomePage ? "relative bg-[#F8F8F8]" : ""}
      style={
        isHomePage
          ? {
            backgroundImage: `url(${banner_bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            minHeight: '100vh',
          }
          : {}
      }
    >
      {isHomePage && <div className="absolute inset-0 bg-black/20 rounded-lg  transition-opacity duration-700 opacity-100  -z-10" />}

      <Navbar />
      <SubNavBar />

      <Box className=''>
        <ScrollToTop />
        <Routes>

          <Route path="/*" element={<Homepage />} />
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/otp" element={<OtpPage />} />
          <Route path="/map" element={<MapView />} />
          <Route path="/searchmap" element={<SearchMapComponent />} />

          {/* Private Routes (Protected) */}
          <Route path="/addproperty22" element={
            <PrivateRoute>
              <AddProperty2 />
            </PrivateRoute>
          } />
          <Route path="/addproperty" element={
            <PrivateRoute>
              <AddPropertyPage />
            </PrivateRoute>
          } />

          <Route path="/addproject" element={
            <PrivateRoute>
              <AddProjectPage />
            </PrivateRoute>
          } />

          <Route path="/editproperty/:propertyId" element={
            <PrivateRoute>
              <EditProperty
              />
            </PrivateRoute>
          } />

          <Route path="/addservice" element={
            <PrivateRoute>
              <AddServiceForm
              />
            </PrivateRoute>
          } />



          <Route path="/propertydetail/:propertyId" element={<PropertyDetailPage />}>
            <Route path="gallery" element={<ShowPropertyGalleryPage />} />
            <Route path="imageswithdetail" element={<AllImagesPage />} />
          </Route>

          <Route path="/project/:projectId" element={

            <ProjectDetailsPage />
          } />


          <Route path="/projects/list/:query" element={

            <ProjectsSearchListPage />
          } />


          <Route path="/searchresult/:query" element={

            <SearchResultPage />
          } />

          <Route path="/allproperties/:query" element={

            <AllPropertyPage />
          } />


          <Route path="/service/list/:query" element={

            <ServiceListPage />
          } />

          <Route path="/relationship/management" element={

            // <RelationShipManagementPage />
            <RelationshipManager />
          } />

          <Route path="/profile" element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          } />
          <Route path="/editprofile/:id" element={
            <PrivateRoute>
              <EditProfilePage />
            </PrivateRoute>
          } />

          <Route path="/bankaunction" element={

            <BankAunctionPage2 />
          } />

          {/* <Route path="/bankaunction2" element={

          <BankAunctionPage />
        } /> */}


          <Route path="/VoiceInput" element={

            <VoiceInput />
          } />

          <Route path="/add" element={

            <AddPropertyComponent />
          } />

          <Route path="/LocationComponent" element={

            <LocationComponent />
          } />

          <Route path="/emi-calculator" element={

            <EMICalculator />
          } />

          <Route path="/property-services" element={<AllServices />} />

          <Route path="/about-us" element={<AboutPage />} />




        </Routes>
        <HelpCenterButton /> {/* 👈 Add this here */}
        <Footer />
        <Toaster position='top-right' />
        {/* <MapView/> */}
      </Box>
    </div>
    // </GoogleMapsLoader>
  );
}

export default App;
